import { ErrorLike } from '@apollo/client';
import { CircleAlert } from 'lucide-react';
import { useTransition } from 'react';

import { Alert, AlertDescription, AlertTitle } from '../ui/alert';
import { Button } from '../ui/button';

export interface ErrorAlertProps {
  description?: string;
  error?: ErrorLike;
  onRetry?: () => void;
  title: string;
}

export function ErrorAlert({ description, error, onRetry, title }: ErrorAlertProps) {
  const [isPending, startTransition] = useTransition();

  const handleRetry = () => {
    startTransition(() => {
      onRetry?.();
    });
  };

  return (
    <Alert className="w-max" variant="destructive">
      <CircleAlert />
      <div className="space-between flex items-center gap-8">
        <div>
          <AlertTitle>{title}</AlertTitle>
          {error && <AlertDescription>{error.message}</AlertDescription>}
          {description && <AlertDescription>{description}</AlertDescription>}
        </div>
        {onRetry && (
          <Button
            disabled={isPending}
            loading={isPending}
            variant="secondary"
            onClick={handleRetry}>
            Retry
          </Button>
        )}
      </div>
    </Alert>
  );
}
